/**
 * Base path for the app: '/web-ui' when served under tower (e.g. tower.folge.me/web-ui)
 * or '' when served at root (e.g. cloud.folge.me). Set at build time via VITE_BASE_PATH.
 */
const raw = import.meta.env.VITE_BASE_PATH ?? '/web-ui';
export const BASE_PATH =
  raw === '/' || raw === '' ? '' : raw.replace(/\/$/, '');
